// extracted by mini-css-extract-plugin
export default {"weddingAbc":"WeddingAbc_weddingAbc__Q1neQ"};